export default __webpack_public_path__ + "static/media/cognitive-shadow.b25c018b.svg";